import Title from 'components/ui/Title';
import Editorial from 'components/ui/Editorial';
import Flex from 'components/grid/Flex';
import React from 'react';
import Button from 'components/ui/Button';
import Link from 'components/utils/Link';
import Icon from 'components/ui/Icon';
import ChevronRight from 'components/ui/Icon/actions/ChevronRight';

export type RegistrationRedirectProps = {
  title: React.ReactNode;
  children?: React.ReactNode;
  buttonLabel?: React.ReactNode;
  to?: string;
};

function RegistrationRedirect({
  title,
  children,
  buttonLabel,
  to,
}: RegistrationRedirectProps): JSX.Element {
  return (
    <Flex direction="column" gap="md">
      <Title as="h2" size={3}>
        {title}
      </Title>
      {children ? <Editorial>{children}</Editorial> : null}
      {buttonLabel && to ? (
        <div>
          <Button as={Link} to={to} icon={ChevronRight}>
            {buttonLabel}
          </Button>
        </div>
      ) : null}
    </Flex>
  );
}

export default RegistrationRedirect;
